import { render, staticRenderFns } from "./AlterarProfissionalSolicitante.vue?vue&type=template&id=492976ac&"
import script from "./AlterarProfissionalSolicitante.vue?vue&type=script&lang=js&"
export * from "./AlterarProfissionalSolicitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports